import { render, staticRenderFns } from "./charts_ad.vue?vue&type=template&id=635357a0&scoped=true"
import script from "./charts_ad.vue?vue&type=script&lang=js"
export * from "./charts_ad.vue?vue&type=script&lang=js"
import style0 from "./charts_ad.vue?vue&type=style&index=0&id=635357a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635357a0",
  null
  
)

export default component.exports